import React, { useState, useEffect } from 'react';
import { t } from '@lingui/macro';

import { Flex, H1, P, SearchInput } from '@decisiv/ui-components';

import Helmet from '../../components/SEO/Helmet';
import CommandErrorsTable from '../../components/CommandErrorsTable';
import WrapperWithLoading from '../../components/WrapperWithLoading';
import CommandErrorsApi from '../../api/command_errors';
import { CommandErrorsSection, LineDivider, ContentSection } from './style';

const matchesSearch = (entry, search) => {
  const {
    error_type: errorType,
    title,
    detail_template: detailTemplate,
    description,
    code,
  } = entry.attributes || {};

  return [errorType, title, detailTemplate, description, code]
    .filter(Boolean)
    .some((value) => value.toLowerCase().includes(search));
};

export default function CommandErrorsPage() {
  const [commandErrors, setCommandErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const result = await CommandErrorsApi.fetchCommandErrors();

      if (result.data) {
        setCommandErrors(result.data);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const search = searchInput.trim().toLowerCase();
  const visibleErrors = search
    ? commandErrors.filter((entry) => matchesSearch(entry, search))
    : commandErrors;

  return (
    <>
      <Helmet title={t`Errors`} description={t`Error Catalog`} />
      <CommandErrorsSection
        flexDirection="column"
        justifyContent="center"
        padding={2}
        flex="none"
        flexGrow="0"
      >
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Flex flex={1} title="Errors">
            <H1>{t`Errors`}</H1>
          </Flex>
          <SearchInput
            value={searchInput}
            width={24}
            label={t`Search errors`}
            name="commandErrorSearch"
            placeholder={t`Search by type, title or message`}
            onChange={(event) => setSearchInput(event.target.value)}
            size="small"
            searchDisabled={false}
          />
        </Flex>
        <P shade={1}>
          {t`Catalog of the standard error types an integration invocation can return. Every command reports failures using these types with the same user-facing message, and the code on an error response identifies its entry in this catalog.`}
        </P>
      </CommandErrorsSection>
      <LineDivider />
      <ContentSection flexDirection="column">
        <WrapperWithLoading loading={loading}>
          <CommandErrorsTable
            commandErrors={visibleErrors}
            totalRecords={visibleErrors.length}
          />
        </WrapperWithLoading>
      </ContentSection>
    </>
  );
}
